import { createFileRoute } from "@tanstack/react-router";

import { orderPageSearchParamsSchema } from "../../../pages/order-page/types";

export const Route = createFileRoute("/_layout-main/orders/$orderId")({
  validateSearch: orderPageSearchParamsSchema,
});
